import apiCall from '../index'

const apiService = '/gsencuesta/api/v1/proyecto'
const apiServiceLogo = '/gsencuesta/api/v1/recurso'

const service = {
  findAll(params) {
    const query = `?limit=${params.limit}&page=${params.page}&query=${params.query}&sortBy=${params.sortBy}&idInstitucion=${params.idInstitucion}`
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  findAllByUsuario(params) { // PARA GOOGLE MAPS
    const query = `/ByUser?query=${params.sortBy}&idUsuario=${params.idUsuario}`
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  create(model) {
    const authorization = 'Authorization'
    const formData = new FormData()
    formData.append('idProyecto', model.idProyecto)
    formData.append('nombre', model.nombre)
    formData.append('abreviatura', model.abreviatura)
    formData.append('nombreResponsable', model.nombreResponsable)
    formData.append('logo', model.logo)
    formData.append('latitud', model.latitud)
    formData.append('longitud', model.longitud)
    formData.append('idInstitucion', model.institucion.idInstitucion)
    formData.append('orientacion', 'H')

    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .post(apiService, formData)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  update(model) {
    const authorization = 'Authorization'
    const formData = new FormData()
    formData.append('idProyecto', model.idProyecto)
    formData.append('nombre', model.nombre)
    formData.append('abreviatura', model.abreviatura)
    formData.append('nombreResponsable', model.nombreResponsable)
    formData.append('logo', model.logo)
    formData.append('latitud', model.latitud)
    formData.append('longitud', model.longitud)
    formData.append('idInstitucion', model.institucion.idInstitucion)
    formData.append('orientacion', 'H')
    /* formData.append('logo', model.logo)
    formData.append('idProyecto', model.idProyecto)
    formData.append('nombre', model.nombre) */
    // formData.append('proyecto', `{"idProyecto":${model.idProyecto},"nombre":"${model.nombre}","abreviatura":"${model.abreviatura}","nombreResponsable":"${model.nombreResponsable}","longitud":"${model.longitud}","latitud":"${model.latitud}","institucion":{"idInstitucion":${model.institucion.idInstitucion}} }`)

    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .put(apiService, formData)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  findLogo(params) {
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .get(`${apiServiceLogo}/proyecto/${params.idProyecto}`, {
          responseType: 'arraybuffer',
        })
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  delete(params) {
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .delete(`${apiService}/${params.id}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
